<script setup lang="ts">
import { computed } from 'vue'

interface Props {
  tutorName: string
  videoTitle?: string
  playbackId?: string | null
}

const props = withDefaults(defineProps<Props>(), {
  videoTitle: 'Meet Your Tutor',
  playbackId: null
})

// Mux stream URL for HLS playback
const videoUrl = computed(() => {
  if (!props.playbackId) return null
  return `https://stream.mux.com/${props.playbackId}.m3u8`
})

// Mux thumbnail URL
const posterUrl = computed(() => {
  if (!props.playbackId) return null
  return `https://image.mux.com/${props.playbackId}/thumbnail.jpg?time=0`
})
</script>

<template>
  <section class="bg-white rounded-2xl shadow-sm p-6">
    <h2 class="text-xl font-semibold text-gray-900 mb-4">Introduction Video</h2>

    <!-- Native Video Player (when playbackId is available) -->
    <div v-if="playbackId" class="relative rounded-xl overflow-hidden shadow-lg">
      <video
        controls
        playsinline
        preload="metadata"
        :poster="posterUrl"
        class="w-full aspect-video bg-black"
      >
        <source :src="videoUrl" type="application/x-mpegURL">
        Your browser does not support the video tag.
      </video>
    </div>

    <!-- Placeholder (when no video) -->
    <div v-else class="relative bg-gray-100 rounded-xl overflow-hidden">
      <div class="aspect-video flex items-center justify-center">
        <div class="text-center text-gray-400">
          <span class="material-symbols-outlined text-5xl mb-2">videocam_off</span>
          <p class="text-sm">No introduction video available</p>
        </div>
      </div>
    </div>
  </section>
</template>
